import styled from 'styled-components';

export const ActionsGroup = styled.div`
    && {
        // TODO: This should be converted to a
        // <Drawer.Actions /> component.
        display: flex;
        width: 100%;
        gap: 10px;
    }
`;
